export default "__VITE_ASSET__CrSx_E7y__"